import { Component, OnInit, ChangeDetectionStrategy, Output, EventEmitter, Input } from '@angular/core';

@Component({
    selector: 'app-admin-setting-actions',
    templateUrl: './actions.component.html',
    changeDetection: ChangeDetectionStrategy.Default,
})
export class AppAdminSettingActionComponent  {

    @Output() editData = new EventEmitter<any>();
    @Output() deleteData = new EventEmitter<any>();
}
